export default "/images/img-6.jpg?22e5e101c600a7c016a1f18889f81876";